"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _reactDragDrawer = _interopRequireDefault(require("react-drag-drawer"));

var _IconActionClose = _interopRequireDefault(require("../Icons/IconActionClose"));

var _cogoToast = _interopRequireDefault(require("cogo-toast"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n   /* This will prevent scrolling in the background when the modal is open */\n   body {\n    overflow: ", ";\n  }\n.ModalDrawerContainer {\n  /* important addd to overwrite package css */\n  overflow: hidden !important; /* stylelint-disable-line */\n}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var StyledModalActions = function StyledModalActions(_ref) {
  var children = _ref.children,
      position = _ref.position;
  return /*#__PURE__*/_react.default.createElement(ModalActions, {
    position: position
  }, children);
};

var Modal = function Modal(_ref2) {
  var title = _ref2.title,
      canClose = _ref2.canClose,
      children = _ref2.children,
      showModal = _ref2.showModal,
      setShowModal = _ref2.setShowModal,
      small = _ref2.small,
      large = _ref2.large,
      className = _ref2.className,
      width = _ref2.width,
      showToast = _ref2.showToast,
      toastText = _ref2.toastText,
      toastHideTime = _ref2.toastHideTime,
      drawerProps = _ref2.drawerProps,
      onClose = _ref2.onClose,
      otherProps = _objectWithoutProperties(_ref2, ["title", "canClose", "children", "showModal", "setShowModal", "small", "large", "className", "width", "showToast", "toastText", "toastHideTime", "drawerProps", "onClose"]);

  var isShowingToast = (0, _react.useRef)(false);

  var handleOnRequestClose = function handleOnRequestClose() {
    if (canClose) {
      setShowModal(!showModal);
      onClose();
    }

    if (showToast && !isShowingToast.current) {
      isShowingToast.current = true;

      _cogoToast.default.warn(toastText, {
        hideAfter: toastHideTime
      });

      setTimeout(function () {
        isShowingToast.current = false;
      }, toastHideTime * 1000);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(GlobalStyle, {
    isModalOpen: showModal
  }), /*#__PURE__*/_react.default.createElement(StyledDrawer, _extends({
    open: showModal,
    onRequestClose: handleOnRequestClose
  }, drawerProps, {
    containerElementClass: "ModalDrawerContainer"
  }), /*#__PURE__*/_react.default.createElement(ModalContainer, _extends({}, otherProps, {
    className: className,
    small: small,
    large: large,
    width: width
  }), canClose ? /*#__PURE__*/_react.default.createElement(ModalCloser, {
    onClick: function onClick() {
      setShowModal(!showModal);
      onClose();
    }
  }, /*#__PURE__*/_react.default.createElement(_IconActionClose.default, {
    color: "#505050"
  })) : '', title ? /*#__PURE__*/_react.default.createElement(ModalTitleBar, null, title) : '', /*#__PURE__*/_react.default.createElement(ModalContent, {
    modalTitle: title
  }, children))));
};

var GlobalStyle = (0, _styledComponents.createGlobalStyle)(_templateObject(), function (_ref3) {
  var isModalOpen = _ref3.isModalOpen;
  return isModalOpen && 'hidden';
});
var StyledDrawer = (0, _styledComponents.default)(_reactDragDrawer.default).withConfig({
  displayName: "StyledDrawer"
})(["z-index:9999999;"]);

var ModalContainer = _styledComponents.default.div.withConfig({
  displayName: "ModalContainer"
})(["background:white;width:", ";border:1px solid #ccc;box-shadow:0 0 8px rgba(0,0,0,0.1);border-radius:5px;display:flex;max-height:90vh;flex-direction:column;height:100%;position:relative;overflow-x:auto;font-family:", ";@media screen and (max-width:950px){width:calc(100vw - 3rem);}"], function (_ref4) {
  var small = _ref4.small,
      large = _ref4.large,
      width = _ref4.width;
  return width ? width : small ? '50rem' : large ? '100rem' : '60rem';
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.font;
});

var ModalTitleBar = _styledComponents.default.div.withConfig({
  displayName: "ModalTitleBar"
})(["width:100%;padding:30px 60px 22px;border-bottom:1px solid #ccc;background-color:#fcfcfc;display:flex;justify-content:center;align-items:center;font-weight:500;font-size:2.1rem;line-height:120%;text-align:center;"]);

var ModalContent = _styledComponents.default.div.withConfig({
  displayName: "ModalContent"
})(["padding:", ";"], function (_ref6) {
  var modalTitle = _ref6.modalTitle;
  return modalTitle ? '30px' : '45px 30px 30px';
});

var ModalCloser = _styledComponents.default.a.withConfig({
  displayName: "ModalCloser"
})(["position:absolute;top:30px;right:30px;z-index:9999;cursor:pointer;&:hover{svg > path{fill:", ";}}"], function (_ref7) {
  var theme = _ref7.theme;
  return theme.brand.primary;
});

var ModalActions = _styledComponents.default.div.withConfig({
  displayName: "ModalActions"
})(["width:100%;display:flex;justify-content:", ";margin-top:40px;align-items:center;> button{margin:0 10px;&:first-of-type{margin-left:0;}&:last-of-type{margin-right:0;}}"], function (_ref8) {
  var position = _ref8.position;
  return handleActionsPosition(position);
});

var handleActionsPosition = function handleActionsPosition(position) {
  switch (position) {
    case 'left':
      return 'flex-start';

    case 'center':
      return 'center';

    case 'right':
      return 'flex-end';

    default:
      return 'flex-start';
  }
};

StyledModalActions.propTypes = {
  children: _propTypes.node,
  position: _propTypes.string
};
StyledModalActions.defaultProps = {
  position: 'right'
};
Modal.propTypes = {
  /** A title to be displayed at the top of the modal. */
  title: _propTypes.string,

  /** Set to true to make the modal closeable. */
  canClose: _propTypes.bool,
  children: _propTypes.node,
  showModal: _propTypes.bool,
  setShowModal: _propTypes.func.isRequired,

  /** Add this prop to display a smaller size of modal. */
  small: _propTypes.bool,

  /** Add this prop to display a larger size of modal. */
  large: _propTypes.bool,

  /** Pass a custom width to modal */
  width: _propTypes.string,

  /** If a toast should be shown when trying to close the modal */
  showToast: _propTypes.bool,

  /** Text for the toast if shown */
  toastText: _propTypes.string,

  /** Time for toast to hide in seconds*/
  toastHideTime: _propTypes.number,
  className: _propTypes.string,

  /** FUnction to execute if closed */
  onClose: _propTypes.func,
  drawerProps: _propTypes.object
};
Modal.defaultProps = {
  onClose: function onClose() {},
  canClose: true,
  showModal: false,
  toastHideTime: 5
};
Modal.ModalActions = StyledModalActions;
Modal.ModalActions.displayName = 'Modal.ModalActions';
var _default = Modal;
exports.default = _default;